import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
// Inter — ASKO saytidagi shrift. O'zimizda yotadi, tashqi manbadan
// yuklanmaydi: internet sekin bo'lsa ham interfeys bir xil ko'rinadi.
import '@fontsource-variable/inter/wght.css';
import './styles.css';
import { applyTheme, readTheme } from './lib/theme';

// Mavzu React'dan oldin qo'llanadi — ochilishda oq lipillash bo'lmasin.
applyTheme(readTheme());

const container = document.getElementById('root');
if (!container) throw new Error('#root topilmadi');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
